import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { Provider } from '@angular/core';
import {
  ApolloClientOptions,
  ApolloLink, DefaultOptions,
  InMemoryCache,
} from '@apollo/client/core';
import { environment } from '../environments/environment';

export const graphqlProvider: Provider = {
  provide: APOLLO_OPTIONS,
  useFactory: apolloOptionsFactory,
  deps: [HttpLink],
};


const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

function apolloOptionsFactory(httpLink: HttpLink): ApolloClientOptions<any> {
  const uri = environment.graphqlUri;
  const link = ApolloLink.from([httpLink.create({ uri })]);

  return {
    link,
    cache: new InMemoryCache({
      addTypename: false,
      resultCaching: false,
      resultCacheMaxSize: 0,
    }),
    defaultOptions: defaultOptions,
  };
}
